import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import internet from 'assets/img/others/20944013.jpg';

const NoInternet = (props) => {
  const [isOnline, setOnline] = useState(navigator.onLine);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      const storedUrl = localStorage.getItem('lastVisitedUrl');
      if (storedUrl) {
        navigate(storedUrl);
        localStorage.removeItem('lastVisitedUrl');
      }
    };

    const handleOffline = () => {
      setOnline(false);
      localStorage.setItem('lastVisitedUrl', window.location.pathname);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [navigate]);

  if (isOnline) {
    return props.children;
  } else {
    return (
      <div className="dark:bg flex w-full flex-col items-center justify-center rounded-[20px] bg-white dark:!bg-navy-900 md:py-12 lg:py-28 3xl:py-40">
        <img src={internet} className="mt-4 w-[400px]" alt="Error" />
        <h1 className="mt-3 text-center text-4xl font-bold text-navy-700 dark:text-white lg:text-5xl">
          Ah, dang. No Internet Connection.
        </h1>
        <p className="mt-4 text-center text-sm font-normal text-navy-700 dark:text-white xl:mt-8 xl:text-lg">
          It seems you’re not connected to the internet. Please check your
          connection.
        </p>
      </div>
    );
  }
};

export default NoInternet;
